module.exports = __webpack_public_path__ + "img/chewie.4a589736.svg";